import React from 'react';

import Cards from '../../../elements/cards/Cards';

// import styles from './Offer.module.scss';


class Offer extends React.Component {
  constructor(props) {
    super(props);

    this.offers = [
      { id: 1, v: 'Projektowanie i produkcja schodów drewnianych' },
      { id: 2, v: 'Możliwość wizualizacji 3D' },
      { id: 3, v: 'Montaż u klienta' },
      { id: 4, v: 'Renowacja używanych schodów' },
      { id: 5, v: 'Wytwarzanie innych elementów drewnianych' },
    ];
  }

  render() {
    return (
      <Cards cards={this.offers} />
    );
  }
}

export default Offer;
